import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useOverlayContext } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { routes } from '~/constants';
import { useLocaleKeys } from '~/i18n';
import { Intent } from '~/infra/access-control';
import IntegrationCard from '../../IntegrationCard/IntegrationCard';
import StanfordTaxLogo from '../../logos/stanford-tax.svg';
import { ConnectStanfordTaxModal } from '../ConnectStanfordTaxModal/ConnectStanfordTaxModal';
export const GetStanfordTaxCardTID = (parentTestId)=>getTestIds(parentTestId);
export const StanfordTaxCard = (param)=>{
    let { isConnected } = param;
    const { t: stanfordTaxTexts } = useLocaleKeys('integrations.setup.stanfordTax');
    const { t: sharedTexts } = useLocaleKeys('integrations.apps.shared');
    const { StanfordTaxCardTID } = useMemo(()=>GetStanfordTaxCardTID(), []);
    const navigate = useNavigate();
    const { showModal } = useOverlayContext();
    const openConnectModal = ()=>{
        showModal({
            biName: 'connect_stanford_tax_modal',
            closeOnEscapeKey: true,
            closeOnClickOutside: true,
            content: (param)=>{
                let { dismissModal, registerCanDismiss } = param;
                return /*#__PURE__*/ _jsx(ConnectStanfordTaxModal, {
                    dismissModal: dismissModal,
                    registerCanDismiss: registerCanDismiss
                });
            }
        });
    };
    const handleClick = ()=>{
        if (isConnected) {
            navigate(routes.stanfordTaxSetup);
        } else {
            openConnectModal();
        }
    };
    return /*#__PURE__*/ _jsx(IntegrationCard, {
        testId: StanfordTaxCardTID.Card(),
        icon: /*#__PURE__*/ _jsx(StanfordTaxLogo, {
            width: 40,
            height: 40
        }),
        title: stanfordTaxTexts.name(),
        subTitle: stanfordTaxTexts.cardSubTitle(),
        mainAction: /*#__PURE__*/ _jsx(IntegrationCard.MainActionButton, {
            bi: {
                name: isConnected ? 'manage_stanford_tax_connection' : 'connect_stanford_tax'
            },
            intent: Intent.StanfordTaxManageConnection,
            testId: StanfordTaxCardTID.Action(),
            onClick: handleClick,
            children: isConnected ? sharedTexts.manageConnection() : sharedTexts.connectButton()
        })
    });
};
